import React, { useEffect, useState } from 'react';
import { useGetAssignmentMarkWithStudentIdAddAssignmentIdQuery, } from '../../features/assignmentMark/assignmentMarkApi';
import { useGetAssignmentWithVideoIdQuery } from '../../features/assignment/assignmentApi';
import { useSelector } from 'react-redux';
import { selectUser } from '../../features/auth/selector';
import CustomModal from '../../Components/CustomModal/CustomModal';
import AssignmentModalContent from './AssignmentModalContent';
import ButtonLoading from '../../Components/UiLoadingComponents/ButtonLoading';

const AssignmentTab = ({ videoId }) => {
    const { user } = useSelector(selectUser)
    const [isOpen, setIsOpen] = useState(false);
    const [shouldGetAssignmentMark, setShouldGetAssignmentMark] = useState(false)
    const { data: assignmentData, isLoading: isAssignmentLoading, } = useGetAssignmentWithVideoIdQuery(videoId)

    const { data: assignmentMarkData, isLoading: isAssignmentMarkLoading } = useGetAssignmentMarkWithStudentIdAddAssignmentIdQuery({ studentId: user.id, assignment_id: assignmentData?.length ? assignmentData[0].id : undefined }, { skip: !shouldGetAssignmentMark })


    useEffect(() => {
        if (assignmentData?.length) {

            setShouldGetAssignmentMark(true)
        }
    }, [assignmentData, isAssignmentLoading])
    const isAssignmentExist = Boolean(assignmentData?.length)
    const isAssignmentSubmitted = Boolean(assignmentMarkData?.length)

    const handleModalOpen = () => {
        setIsOpen(pre => !pre)
    }

    let content = null;

    if (isAssignmentLoading || isAssignmentMarkLoading) {
        content = <div>
            <ButtonLoading></ButtonLoading>
        </div>
    } else if (isAssignmentExist) {

        if (isAssignmentSubmitted) {

            if (assignmentMarkData[0]?.status === 'pending') {

                content = <>
                    <CustomModal open={isOpen} setOpen={setIsOpen}>
                        <h2 className='text-center text-xl'>{assignmentMarkData[0]?.title}</h2>
                        <p className='mt-5 text-xl'>
                            Your submitted Link : <span className='text-cyan-500'>
                                {assignmentMarkData[0].repo_link}
                            </span>
                        </p>
                    </CustomModal>
                    <button onClick={handleModalOpen} className='assignment-button pending'>
                        Mark pending
                    </button>
                </>

            } else {
                content = <>
                    <button className='assignment-button'>
                        Assignment Mark <span className=' font-bold'>
                            {assignmentMarkData[0].mark}/{assignmentData[0].totalMark}
                        </span>
                    </button>

                </>
            }
        } else {
            // assignment exits but not submitted 
            content = <>
                <button onClick={handleModalOpen}
                    className="assignment-button notSubmitted">
                    এসাইনমেন্ট
                </button>
                <CustomModal open={isOpen} setOpen={setIsOpen}>
                    <AssignmentModalContent setIsOpen={setIsOpen} assignmentData={assignmentData[0]} user={user} ></AssignmentModalContent>
                </CustomModal>

            </>
        }

    }

    return (
        <>
            {
                content
            }

        </>
    );
};

export default AssignmentTab;